import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import debounce from 'lodash.debounce';

import store from '@/store';
import { setWindowWidth } from '@/store/core';

import { HelmetProvider } from 'react-helmet-async';
import AppHelmet from '@/Helmet';
import AppRoutes from '@/routes';

import 'antd/dist/reset.css';
import '@/assets/styles/app.sass';
import '@/assets/styles/index.scss';

const App = () => {
  useEffect(() => {
    const onResize = (e: UIEvent) => {
      const width = (e.target as Window).innerWidth;
      store.dispatch(setWindowWidth(width));
    };
    window.addEventListener(
      'resize',
      debounce(e => onResize(e), 200)
    );

    store.dispatch(setWindowWidth(window.innerWidth));
  }, []);

  return (
    <HelmetProvider>
      <Provider store={store}>
        <AppHelmet />
        <AppRoutes />
      </Provider>
    </HelmetProvider>
  )
};

export default App;
